import { render, staticRenderFns } from "./introduceDialog.vue?vue&type=template&id=feb98c08&scoped=true"
import script from "./introduceDialog.vue?vue&type=script&lang=js"
export * from "./introduceDialog.vue?vue&type=script&lang=js"
import style0 from "./introduceDialog.vue?vue&type=style&index=0&id=feb98c08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb98c08",
  null
  
)

export default component.exports